import clsx from 'clsx';
import { observer } from 'mobx-react';
import { ParticipantResource } from '../../../../../../../../../ParticipantsStore/Types';
import { T } from '../../../../../../../../../Translations';
import AddParticipantStore from '../../../../../../Store';
import SelectedUsers from '../../../SelectedUsers';

export interface Props {
  participants: ReadonlyArray<ParticipantResource>;
  store: AddParticipantStore;
}

function Participants({ participants, store }: Props) {
  return (
    <>
      <div className="md:max-h-[30vh] md:h-[30vh] sm:max-h-[20vh] sm:h-[20vh] text-sm overflow-y-auto">
        <SelectedUsers participants={participants} removeParticipant={store.removeParticipant} />
      </div>
      <div
        className={clsx(
          'cursor-pointer rounded-md bg-teal-600 text-white px-3 py-2 text-sm w-24 text-center mt-4',
        )}
        onClick={store.submit}
      >
        <T kind="Submit" />
      </div>
    </>
  );
}

export default observer(Participants);
